import { RichiestaDTO } from '@framework/api-client';
import React from 'react';

export interface ContentCardWrapperProps {
  submission?: RichiestaDTO | null;
  children?: React.ReactNode;
}

/**
 * Wrapper
 */
export function ContentCardWrapper(props: ContentCardWrapperProps) {
  const { submission, children } = props;

  // return process.env.BUILD_FLAGS_DOSSIERS &&
  //   submission?.idIstanzaProcedimentoPratica ? (
  //   <DossierCardWrapper submission={submission}>{children}</DossierCardWrapper>
  // ) : (
  //   <>{children}</>
  // );

  return <>{children}</>;
}
